/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseProductsInnerAllOfModifiersInner
 */
export interface GetReportTab200ResponseProductsInnerAllOfModifiersInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseProductsInnerAllOfModifiersInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInnerAllOfModifiersInner
     */
    priceImpact?: number;
}

/**
 * Check if a given object implements the GetReportTab200ResponseProductsInnerAllOfModifiersInner interface.
 */
export function instanceOfGetReportTab200ResponseProductsInnerAllOfModifiersInner(value: object): value is GetReportTab200ResponseProductsInnerAllOfModifiersInner {
    return true;
}

export function GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSON(json: any): GetReportTab200ResponseProductsInnerAllOfModifiersInner {
    return GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseProductsInnerAllOfModifiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
    };
}

export function GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSON(json: any): GetReportTab200ResponseProductsInnerAllOfModifiersInner {
    return GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSONTyped(value?: GetReportTab200ResponseProductsInnerAllOfModifiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'priceImpact': value['priceImpact'],
    };
}

